import LogRocket from "logrocket";
import Vue from "vue";
import { Vue as SentryVue } from "@sentry/integrations";

import { isProduction, isLocal } from "@/utils/constants";

// Setup a new Sentry BrowserClient even though we've already instantiated one in index.html
// This binds the Vue integration to the main Sentry hub
if (!isLocal && window.Sentry) {
  const client = new window.Sentry.BrowserClient({
    dsn: "https://701cebe77b6941c2aef160f063fa06da@sentry.io/1359153",
    environment: process.env.VUE_APP_ENV,
    release: process.env.VUE_APP_SENTRY_RELEASE,
    integrations: [
      ...window.Sentry.defaultIntegrations,
      new SentryVue({ Vue, attachProps: true })
    ]
  });
  window.Sentry.getCurrentHub().bindClient(client);
}

// Setup LogRocket
const unsubscribedPath = window?.location?.pathname === "/unsubscribed";
if (isProduction && !unsubscribedPath) {
  LogRocket.init("54j2a5/promo-app");

  // Configure Sentry to use LogRocket
  LogRocket.getSessionURL(sessionURL => {
    window.Sentry && window.Sentry.configureScope(scope => {
      scope.setExtra("sessionURL", sessionURL);
    });
  });
}


// Setup custom error handler in dev due to... https://github.com/vuejs/vue/issues/8433
Vue.config.errorHandler = (err, vm, info) => {
  if (!isProduction) {
    Vue.util.warn(`Error in ${info}: "${err.toString()}"`, vm);
  }
};
